import { Image, Text } from '@react-pdf/renderer'
import { sanitizeForPdf } from 'features/reporting/pdfGeneration/utils/formatters'

import { workPackPdfStyles as styles } from './workPackPdfStyles'
import { WorkPackDrawing, WorkPackImage } from './workPackTypes'

export const WorkPackPdfDrawing = ({
  drawing,
  image,
}: {
  drawing: WorkPackDrawing
  image: WorkPackImage
}) => (
  <>
    <Text style={styles.note}>{sanitizeForPdf(image.name)}</Text>
    <Image src={image.dataUrl} style={styles.image} />
    <Text style={styles.note}>
      Gray Z labels identify source zones; teal P labels identify planned
      locations. Refer to the matching numbered instructions in this pack.
    </Text>
    <Text style={styles.heading} minPresenceAhead={30}>
      Drawing legend
    </Text>
    {drawing.marks.map((mark) => (
      <Text key={mark.title} style={styles.legendRow}>
        {mark.title}: {sanitizeForPdf(mark.description)}
      </Text>
    ))}
  </>
)
